define('views/register/financial',[
    'backbone',
    'views/_base/baseview',
    'text!views/register/financial.html',
    'views/shared/form/form_component',
    'models/user/register/register',
    'models/shared/user/user',
    'views/user/register/financial/questionsandanswers',
    'models/shared/qanda/questionandanswers',
    'views/user/register/financial/failure',
    'views/user/register/financial/productselection',
], function(Backbone, BaseView, Template, FormComponent, RegisterModel, UserModel, QsandAsComponent, QsandAsModel, FailureView, ProductSelectionView){
    'use strict';

    return BaseView.extend({
        className: 'register-container',
        tagName  : 'div',
        isRender : false,
        needsAuth: true,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};
            
            this.elementName = options.elementName;

            // Dictates what program the user enters (VirtualCard, GPRDebitCard, etc)
            this.product = options.product;

            // If user was routed here from a CIP trigger point
            this.is_cip = options.isTrigger;

            this.site_version = pf.getContent('version.id');

            // if(this.site_version == enums.siteVersion.bcbssc && !this.is_cip){
            //     var form_set_id = enums.registrationSetId.standard;
            // } else {

            //     if(this.is_cip){

            //         if(this.site_version == enums.siteVersion.bcbssc){
            //             var form_set_id = enums.registrationSetId.wellness_cip;
            //         } else {
            //             var form_set_id = enums.registrationSetId.cip;
            //         }
                    
            //         var cip_form_id = 15;

            //     } else {

            //         if(this.site_version == enums.siteVersion.bcbsaz){
            //             var form_set_id = enums.registrationSetId.bcbsaz;
            //         } else {
            //             var form_set_id = enums.registrationSetId.regular;
            //         }
                    
            //     }
                
            // }

            var form_id = (this.is_cip) ? enums.registrationId.cip : enums.registrationId.regular,
                form_options = {
                    id   : (this.is_cip) ? enums.registrationId.cip_page_one : enums.registrationId.financial,
                    depth: 2
                };

            this.registration = pf.getFeatureById(form_id, form_options);

            this.registration_form = null;

            this.user_model = null;
            this.user_model_json = null;

            this.number_of_failures_in_session = 0;

            this.response_message = null;
            this.response = null;

            startPanoScrollAnimator('.register-content-container', .25);

            // console.log('financial registration initialize', this, form_options);

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.addRegistrationForm();

            return this;
        },

        loadData: function(){
            var that = this;

            store.getStoreItem(enums.modelsEnum.UserInfo, { ID: pf.session.get('UserGUID') }, false, true, true, function(Data){
                that.user_model = new UserModel(Data);

                that.user_model_json = that.user_model.toJSON();

                that.render();
            });

        },

        addRegistrationForm: function(){
            var that = this;

            if(this.is_cip){
                var form_fields = pf.getContent('register.content.form.cip.fields'),
                    button_data = pf.getContent('register.content.form.cip.button_component'),
                    route = pf.getContent('register.content.form.cip.route'),
                    form_page = 0;
            } else {
                var form_fields = pf.getContent('register.content.form.financial.fields'),
                    button_data = pf.getContent('register.content.form.financial.button_component'),
                    route = pf.getContent('register.content.form.financial.route'),
                    form_page = 1;
            }

            console.log('form fields:', form_fields);
            

            if(_.isObject(this.registration)){

                // this is super gross. it's to get around using a static financial form in lieu of features for BCBSLA. TODO modify form component


                if (this.site_version === enums.siteVersion.bcbsla) {
                    this.registration_form = new FormComponent({
                        elementName: '.js-register-form',
                        button_data: button_data,
                        route      : route,
                        feature    : this.registration,
                        fields: form_fields,
                        form_type  : enums.formType.standard,
                        validated  : function(fields, confirm){
    
                            // console.log('registration_form',fields, confirm);
    
                            that.registerUser();
    
                        },
                        success    : function(end){
                            // console.log('addRegistrationForm success:',end);
                            // Route to next step or home
                            that.registrationSuccess();
                        },
                        error      : function(errors){
                            // console.log('addRegistrationForm error:',errors);
                            that.registrationError();
                        }
                    });
                } else {
                    this.registration_form = new FormComponent({
                        elementName: '.js-register-form',
                        button_data: button_data,
                        route      : route,
                        feature    : this.registration,
                        content_fields: form_fields,
                        form_type  : enums.formType.features,
                        validated  : function(fields, confirm){
    
                            // console.log('registration_form',fields, confirm);
    
                            that.registerUser();
    
                        },
                        success    : function(end){
                            // console.log('addRegistrationForm success:',end);
                            // Route to next step or home
                            that.registrationSuccess();
                        },
                        error      : function(errors){
                            // console.log('addRegistrationForm error:',errors);
                            that.registrationError();
                        }
                    });
                    
                }

                if(_.isObject(this.user_model_json)){

                    // Update the financial forms with potentially known values
                    if(this.user_model_json.FirstName){
                        this.registration_form.updateFieldValue(enums.formComponentTypes.first_name, this.user_model_json.FirstName);
                    }

                    if(this.user_model_json.LastName){
                        this.registration_form.updateFieldValue(enums.formComponentTypes.last_name, this.user_model_json.LastName);
                    }

                    if(this.user_model_json.AddressLine1){
                        this.registration_form.updateFieldValue(enums.formComponentTypes.street_address, this.user_model_json.AddressLine1);
                    }
                    
                    if(this.user_model_json.City){
                        this.registration_form.updateFieldValue(enums.formComponentTypes.city, this.user_model_json.City);
                    }

                    console.log('user model', this.user_model_json, form_fields);

                    // if(this.user_model_json.State){
                    //     this.registration_form.updateFieldValue(enums.formComponentTypes.state, this.user_model_json.State);
                    // }

                    if(this.user_model_json.StateID){
                        this.registration_form.updateFieldValue(enums.formComponentTypes.state, this.user_model_json.StateID);
                    }

                    if(this.user_model_json.ZipCode){
                        this.registration_form.updateFieldValue(enums.formComponentTypes.zipcode, this.user_model_json.ZipCode);
                    }

                    if(this.user_model_json.PhoneNumber){
                        this.registration_form.updateFieldValue(enums.formComponentTypes.phone, this.user_model_json.PhoneNumber);
                    }

                    // If isFinRegCipRequired is not needed, then hide the DOB and SSN
                    if(this.user_model_json.isFinRegCipRequired === false && !this.is_cip){
                        this.registration_form.removeField(enums.formComponentTypes.date_of_birth);
                        this.registration_form.removeField(enums.formComponentTypes.ssn);
                    }

                }

                if(this.site_version != enums.siteVersion.bcbssc || this.site_version != enums.siteVersion.csnp || this.site_version != enums.siteVersion.centene || this.site_version != enums.siteVersion.bcbskc){
                    this.registration_form.updateFieldValue(enums.formComponentTypes.sms, true);
                }

            }

        },

        registerUser: function(){
            var that = this,
                data = this.registration_form.getFieldValues();

            data.CardType = this.product;
            
            if (this.site_version === enums.siteVersion.bcbsla) {
                data.OIWP = this.$('#smsEmailCheckbox').is(":checked");
            }


            this.user_model.set(data);

            gAnalytics('FinancialSignUp', 'Continue', 'Clicked');

            var financial_registration_endpoint = pf.consumerURL + ((this.is_cip) ? '/CIP' : '/Application');

            that.user_model.save(null, {
                url    : financial_registration_endpoint,
                success: function(model, resp){

                    that.response_message = resp.Message;

                    that.response = resp;

                    // Note: Test/decide whether this is actually needed
                    pf.session.getAuth(function(){});

                    // console.log('user_model success:',model, resp, that);
                    
                    switch(that.response_message){
                        case 'Passed':
                        case 'Skipped':
                        case 'SoftFailed':
                            
                            // Show success message
                            if(_.isFunction(that.registration_form.acknowledgedValidation)){
                                that.registration_form.acknowledgedValidation(true);
                            }

                            break;
                        case 'Failed':                                

                            if(that.number_of_failures_in_session > 0){

                                var failure_view = new FailureView({ model: that.user_model, Message: that.response_message, gender: '', elementName: '#mainRegion' });
                                pf.show(failure_view);

                            } else {

                                that.number_of_failures_in_session++;

                                if(_.isFunction(that.registration_form.updateErrorMessage)){
                                    that.registration_form.updateErrorMessage(pf.getContent('register.content.form.financial.error.could_not_verify'));
                                }
                                
                                // Show error message
                                if(_.isFunction(that.registration_form.acknowledgedValidation)){
                                    that.registration_form.acknowledgedValidation(false);
                                }

                            }

                            break;

                        default:

                            if(that.number_of_failures_in_session > 0){
                                
                                var failure_view = new FailureView({ model: that.user_model, Message: that.response_message, gender: '', elementName: '#mainRegion' });
                                pf.show(failure_view);

                            } else {
                                
                                that.number_of_failures_in_session++;

                                if(_.isFunction(that.registration_form.updateErrorMessage)){
                                    that.registration_form.updateErrorMessage(pf.getContent('register.content.form.financial.error.could_not_verify'));
                                }

                                // Show error message
                                if(_.isFunction(that.registration_form.acknowledgedValidation)){
                                    that.registration_form.acknowledgedValidation(false);
                                }

                            }

                            break;
                    }

                },
                error  : function(model, resp){

                    // console.log('user_model error:',model, resp, that);
                    
                    switch(resp.status){
                        case 400:
                            
                            var x = that.user_model;
                            that.response_message = resp.responseJSON.Message;
                            
                            if(that.response_message == enums.Errors.CardAttemptLimitReached){
                                
                                if(_.isFunction(that.registration_form.updateErrorMessage)){
                                    that.registration_form.updateErrorMessage(pf.getContent('register.content.form.financial.error.card_limit'));
                                }

                                // Show error message
                                if(_.isFunction(that.registration_form.acknowledgedValidation)){
                                    that.registration_form.acknowledgedValidation(false);
                                }

                            } else {

                                if(that.number_of_failures_in_session > 0){

                                    var failure_view = new FailureView({ model: that.user_model, Message: that.response_message, gender: "", elementName: "#mainRegion" });
                                    pf.show(failure_view);

                                } else {
                                    
                                    that.number_of_failures_in_session++;

                                    if(_.isFunction(that.registration_form.updateErrorMessage)){
                                        that.registration_form.updateErrorMessage(pf.getContent('register.content.form.financial.error.could_not_verify'));
                                    }

                                    // Show error message
                                    if(_.isFunction(that.registration_form.acknowledgedValidation)){
                                        that.registration_form.acknowledgedValidation(false);
                                    }

                                }

                            }

                            break;

                        default:
                            
                            if(_.isFunction(that.registration_form.updateErrorMessage)){
                                that.registration_form.updateErrorMessage(pf.getContent('register.content.form.financial.error.unkown'));
                            }

                            // Show error message
                            if(_.isFunction(that.registration_form.acknowledgedValidation)){
                                that.registration_form.acknowledgedValidation(false);
                            }

                            break;
                    }

                }

            });

        },

        registrationSuccess: function(){
            var that = this,
                tr = '';
                            
            if(this.is_cip){
                pf.session.set({ CIPStatus: 1 });
            }
            
            pf.IsConsumerFinancial = true;

            if(this.response.QandA && this.response.QandA != null){
                tr = this.response.QandA.TR;
            }

            if(this.response_message == 'SoftFailed' && tr != 'UnderAgedUser'){

                if(this.response.QandA != null ){

                    // Questions and Answers Model
                    this.q_and_a_model = new QsandAsModel();

                    var q_and_a_model_json = this.q_and_a_model.toJSON(),
                        q_and_a = this.response.QandA;
                    
                    if(this.response.QandA.TR == 'questions'){
                        
                        var qsandAsComponent = new QsandAsComponent({
                            elementName: '#mainRegion',
                            qamodel    : q_and_a,
                            Message    : this.response_message,
                            product    : this.product,
                            umodel     : this.user_model.attributes
                        });
                        
                        pf.show(qsandAsComponent);

                    } else {
                        
                        var failure_view = new FailureView({ model: this.user_model, Message: this.response_message, gender: '', elementName: '#mainRegion' });
                        pf.show(failure_view);

                    }

                } else {
                    
                    if(this.is_cip){

                        this.routeAfterCIP();
                        return;

                    }

                    var failure_view = new FailureView({ model: this.user_model, Message: this.response_message, gender: '', elementName: '#mainRegion' });
                    pf.show(failure_view);

                }

            } else if(this.response.AccountGUID != null){
                
                if(this.is_cip){

                    pf.session.getAuth(function(){

                        pf.header.header_state = enums.user_state.logged_in_confirmed;

                        pf.header.render();

                        that.routeAfterCIP();

                    });

                    return;

                }

                store.setStoreItem(enums.modelsEnum.IsRegistration, { Data: 0 });
                
                var product_selection_view = new ProductSelectionView({ elementName: '#mainRegion' });
                pf.show(product_selection_view);

            } else {

                var failure_view = new FailureView({ model: this.user_model, Message: this.response_message, gender: '', elementName: '#mainRegion' });
                pf.show(failure_view);

            }

        },

        registrationError: function(){
            var msg = pf.getContent('register.content.form.financial.button_component.btn_error_message');

            // Reset error message
            if(_.isFunction(this.registration_form.updateErrorMessage)){
                this.registration_form.updateErrorMessage(msg);
            }

        },

        routeAfterCIP: function(){
            var route = getCipTriggerRoute();

            if(route == null || route == 'register/financial/cip'){
                route = 'home';
            }

            pf.navigate(route);
            // window.location.hash = 'wallet';
            removeCipTriggerRoute();
            // window.location.reload();
        },

        close: function(){

            endPanoScrollAnimator();

        }

    });
});

